import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Surface } from '../surface/Surface';
import { Typography } from '../typography/Typography';

// Interface

export interface ErrorMessageProps {
  message?: string;
}

// Styles

const StyledMessage = styled(Surface)`
  ${() => css`
    display: grid;
    justify-content: center;
    align-items: center;
  `};
`;

// JSX

export const ErrorMessage = ({ message }: ErrorMessageProps) => (
  <StyledMessage backgroundColor="utilityInformationBackground">
    <Typography variant="headingSmall">
      {message || 'Sorry, there seems to have been a problem'}
    </Typography>
  </StyledMessage>
);

export default ErrorMessage;
